<!-- 减持资金 -->
<template>
  <div class="jc-wrap">
    <div style="display:flex;align-items: center;">
      <H3Title :title="'减持资金'"></H3Title>
      <div :ltip="szmessage" class="tips"></div>
    </div>
    <div class="chart-1">
      <ChartTpl
        :enableResize='true'
        :elementId='"jcCircle"'
        :width='"100%"'
        :height='"120px"'
        :option='circleOption'
        :originData='circleData'
      ></ChartTpl>
    </div>
    <div class="chart debug">
      <ChartTpl
            :elementId='"jcLine1"'
            :firstTooltip='true'
            :enableResize='true'
            :width='"100%"'
            :height='"248px"'
            :option='line1Option'
            :originData='lineData'
          ></ChartTpl>
    </div>
  </div>
</template>

<script>
import H3Title from "@/components/H3Title";
import ChartTpl from '@/components/ChartTpl.vue';

export default {
  name: "JCCapital",
  components: {
    H3Title,
    ChartTpl
  },
  props: {
    fixedIncreaseMoney:{
      type: Object,
      default: function () {
        return {}
      }
    },
    reductionMoneySeries:{
      type: Array,
      default: function () {
        return []
      }
    }
    
  },
  data() {
    return {
      chart: {},
      szmessage: '减持资金：减少所持有股票对应的金额',
      circleOption: {},
      circleData:[],
      line1Option: {},
      lineData: []
    };
  },
  watch: {
    reductionMoneySeries: {
      handler(newvalue, oldvalue){
        this.init();
      }
    }
  },
  mounted() {
    LTip.width = 200;
    LTip.pos = 'right' ;
    LTip.theme = 'black';
    LTip.reBind();

    if(!this.reductionMoneySeries.length) return;
    this.init();
  },
  methods:{
    initCircle(){
      let { reductionMoney } = this.fixedIncreaseMoney;
      this.circleOption = this.$chartConfigs.oneCircle();
      this.circleOption.data[0] = {
        originData: [{
          min: 0,
          max: 1,
          title: '减持资金',
          values: [
            {
              value: reductionMoney.percentile,
              show: reductionMoney.value 
            }
          ]
        }]
      };

      this.circleData = this.circleOption.data;
    },
    initLine2(){
      this.line1Option = this.$chartConfigs.line1({
        name:'减持资金', 
        dataKey:'reduction_money'
      });
      this.lineData = [{
        originData: this.reductionMoneySeries
      }]
    },
    init(){
      this.initLine2();
      this.initCircle();
    }
  }
};
</script>

<style scoped>
.jc-wrap {
  display: flex;
  flex-direction: column;
}
.chart-1 {
  margin-top: 15px;
  height: 120px;
  flex: 0 0 auto;
  margin-bottom: 11px;
}

.chart {
  flex: 1 1 auto;
}

.tips {
  position: relative;
  background: url('//s.thsi.cn/js/zijinquanxi/assets/pc/tips.png') no-repeat;
  vertical-align: middle;
  margin-left:10px;
  width:24px;
  height: 16px;
}
</style>
